import React from "react";
import { Table } from "antd";
import {
  formatTime,
  WorkplanLineItem,
  Workplan,
  WorkplanResourceAndTimeTotal,
} from "../../data-types";
import styles from "./modal.css";

const { ["workplan-table"]: workplanTable } = styles as any;

export const WorkplanExportPreviewModalBody = ({
  workplan,
}: {
  className?: string;
  workplan: Workplan;
}) => {
  const { rates, lineItems, resourceAndTimeTotals } = workplan;

  const colKeys: TableRow = {};

  // Merge first column (work) with rates
  const columns = [
    ...firstColumn,
    ...rates.map((rate) => {
      const { id, feeEarner, feeEarnerLevel } = rate;

      const title =
        feeEarner?.name && feeEarner?.name !== ""
          ? `${feeEarner?.name} (${feeEarner.feeEarnerLevel?.description}) `
          : `${feeEarnerLevel?.description}`;

      (colKeys as any)[id] = "";

      return {
        title,
        dataIndex: id,
        key: id,
      };
    }),
  ];

  // Set rows for work + time, along with final row of totals
  const rows = [
    ...calculateLineItemRows(lineItems, colKeys),
    ...[calculateTotalsRow(resourceAndTimeTotals, colKeys)],
  ];

  return (
    <div>
      <Table className={workplanTable} dataSource={rows} columns={columns} pagination={false} />
    </div>
  );
};

interface TableRow {
  [index: string]: string | number;
}

const firstColumn = [
  {
    title: "",
    dataIndex: "work",
    key: "work",
  },
];

const calculateLineItemRows = (rowsData: WorkplanLineItem[], colKeys: TableRow): TableRow[] => {
  const retData = [];

  for (let i = 0; i < rowsData.length; i++) {
    retData.push(calculateLineItemRow(rowsData[i], colKeys));
  }

  return retData;
};

const calculateLineItemRow = (rowData: WorkplanLineItem, colKeys: TableRow): TableRow => {
  const { title, id: workItemId, resourceAndTime } = rowData;

  const dataRow: TableRow = {
    key: workItemId,
    work: title,
    ...colKeys,
  };

  for (let i = 0; i < resourceAndTime.length; i++) {
    const rt = resourceAndTime[i];
    console.log(rt);
    const { rateId, timeRange = "" } = rt;
    dataRow[rateId] = timeRange
      ? formatTime(timeRange, {
          lowerUpperSeperator: " - ",
          hoursSuffix: "hrs",
          minutesSuffix: "mins",
          hoursMinutesSeperator: " ",
        })
      : "";
  }

  return dataRow;
};

const calculateTotalsRow = (
  totalsData: WorkplanResourceAndTimeTotal[],
  colKeys: TableRow
): TableRow => {
  const totalsRow: TableRow = {
    key: "totals",
    work: "TOTAL",
    ...colKeys,
  };

  for (let i = 0; i < totalsData.length; i++) {
    const tItem = totalsData[i];
    const { rateId, timeRange = "" } = tItem;
    totalsRow[rateId] = timeRange
      ? formatTime(timeRange, {
          lowerUpperSeperator: " - ",
          hoursSuffix: "hrs",
          minutesSuffix: "mins",
          hoursMinutesSeperator: " ",
        })
      : "";
  }

  return totalsRow;
};
